import { useSearchParams } from "react-router";

import { useActivityFormStore } from "../activity_form_store";

export const useEngagementScopeForm = () => {
  const [searchParams] = useSearchParams();
  const parentActivity = useActivityFormStore((state) => state.parentActivity);
  const { isRole } = useActivityFormStore((state) => state.activityStatus);

  const parentActivityId = searchParams.get("parentActivityId");

  const isEngagementScope = isRole && !!parentActivityId && !!parentActivity;

  return {
    isEngagementScope,
    parentActivityId
  };
};
